import { schema } from 'normalizr';

const integrationSchema = new schema.Entity('integrations', {});

export default integrationSchema;
